import { render } from "./TechStackCard.vue?vue&type=template&id=500336b9&ts=true"
import script from "./TechStackCard.vue?vue&type=script&lang=ts"
export * from "./TechStackCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__